import { render, staticRenderFns } from "./AudioPlayer.vue?vue&type=template&id=671a699e&scoped=true&"
import script from "./AudioPlayer.vue?vue&type=script&lang=ts&"
export * from "./AudioPlayer.vue?vue&type=script&lang=ts&"
import style0 from "./AudioPlayer.vue?vue&type=style&index=0&id=671a699e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "671a699e",
  null
  
)

export default component.exports